<lib-searchmask></lib-searchmask>


<div class="container mt-5">

    <app-pim-notification phase="Home"></app-pim-notification>

    <h2 [innerHTML]="'home.title' | translate"></h2>
    <p [innerHTML]="'home.welcomeText' | translate"></p>

</div>